import { render, staticRenderFns } from "./NeedEstimates.html?vue&type=template&id=676ac4be&scoped=true&external"
import script from "./NeedEstimates.js?vue&type=script&lang=js&external"
export * from "./NeedEstimates.js?vue&type=script&lang=js&external"
import style0 from "./NeedEstimates.vue?vue&type=style&index=0&id=676ac4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676ac4be",
  null
  
)

export default component.exports